import { graphql } from "@/gql/__generated__";

export const activeSeasonDecorationQuery = graphql(`
  query ActiveSeasonDecoration {
    activeSeasonDecoration {
      theme
      startOn
      endOn
    }
  }
`);
